export default __webpack_public_path__ + "static/media/calendar.d782f7d4.svg";